import { Button, Tooltip } from "@mantine/core";
import { IconMail } from "@tabler/icons-react";

import { useSendInviteMail } from "../../api/auth";
import { useConfirm } from "../../hooks/useConfirm";

export default function SendInviteMailModal({ user }) {
  const { mutate } = useSendInviteMail(user.publicId);
  const alreadyInvited = user.config?.isInvited;
  const confirm = useConfirm();

  const openModal = () =>
    confirm({
      title: `Send invite mail to user [${user.firstName} ${user.lastName}] at [${user.email}]?`,
      message: "Please confirm to proceed.",
      confirmLabel: "Send",
      onConfirm: () => mutate(user),
    });

  return (
    <Tooltip label="Send invite mail">
      <Button
        onClick={openModal}
        variant="light"
        color="cyan"
        leftSection={<IconMail />}
        size="xs"
        disabled={alreadyInvited}
      >
        {alreadyInvited ? "Email sent" : "Send invite mail"}
      </Button>
    </Tooltip>
  );
}
